var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopularlocations1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2074_22495",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2074_22495)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2074_22495",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2074_22495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.22922 19.5965C3.55352 11.3684 2.5 10.5239 2.5 7.5C2.5 3.35785 5.85785 0 10 0C14.1421 0 17.5 3.35785 17.5 7.5C17.5 10.5239 16.4465 11.3684 10.7708 19.5965C10.3983 20.1345 9.60164 20.1345 9.22922 19.5965ZM10 10.625C11.7259 10.625 13.125 9.2259 13.125 7.5C13.125 5.7741 11.7259 4.375 10 4.375C8.2741 4.375 6.875 5.7741 6.875 7.5C6.875 9.2259 8.2741 10.625 10 10.625Z",
    fill: "#6F70FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopularlocations1);
export default __webpack_public_path__ + "static/media/popularlocations1.ce49e61d72ab2df6f0ec08b072b09654.svg";
export { ForwardRef as ReactComponent };